module.exports = __webpack_public_path__ + "static/img/Composite-smoke-sensing.aec5ae0c.svg";